module.exports = __webpack_public_path__ + "img/HeaderRow1Placeholder.0ec8bb9b.svg";